<template>
  <div>
    <vs-table maxHeight="815px" maxItems="100" search :data="dataRefinery">
      <template slot="header">
        <h5 class="mt-2 mb-5">
           {{ $t("ShipmentTable.Shipment") }}
        </h5>
      </template>
      <template slot="thead">
        <vs-th>
          {{ $t("RefineryTable.Id") }}
        </vs-th>
        <vs-th>
          {{ $t("RefineryTable.RefineryName") }}
        </vs-th>
        <vs-th>
          {{ $t("RefineryTable.TankerName") }}
        </vs-th>
        <vs-th>
          {{ $t("TankerTable.OilType") }}
        </vs-th>
        <vs-th>
          {{ $t("RefineryTable.TransferVolume") }}
        </vs-th>
        <vs-th>
          {{ $t("TankerTable.TransferTotalVolume") }}
        </vs-th>
        <vs-th sort-key="departed_at_formatted_be">
          {{ $t("RefineryTable.TransferStart") }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ indextr+1 }}
          </vs-td>

          <vs-td :data="data[indextr].station.code">
            {{ data[indextr].station.code }}
          </vs-td>

          <vs-td :data="data[indextr].vessel.name">
            {{ data[indextr].vessel.name }}
          </vs-td>

          <vs-td :data="data[indextr].oil_type">
            {{ data[indextr].oil_type }}
          </vs-td>

          <vs-td :data="data[indextr].volume">
            {{ data[indextr].volume }}
          </vs-td>

          <vs-td :data="data[indextr].volumes">
            {{ getVolume(data[indextr].volumes) }}
          </vs-td>

          <vs-td :data="data[indextr].departed_at_formatted_be">
            {{ data[indextr].departed_at_formatted_be }}
          </vs-td>

        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash'
import { formatNumber } from "@/utils/index";

export default {
  name: "RefineryTableDmtEp",
  data(){
    return{
      formatNumber,
    }
  },
  computed: {
    ...mapState({
      dataRefinery: (state) => state.vesselTrip.data
    }),
  },
  methods:{
    getVolume(data){
        let value = _.chain(data)
          .map((a)=>{
            return Number(a);
          }              
        ).sum()
      return formatNumber(value);
    },
  }
};
</script>

<style>
.tableship{
    height: 100%;
}

</style>
